/* FLUYN theme JS */
(function () {
  'use strict';

  /* ---------- Announcement bar auto-rotate ---------- */
  function initAnnouncementBar() {
    const bar = document.querySelector('.announcement-bar');
    if (!bar || bar.dataset.rotate !== 'true') return;
    const messages = bar.querySelectorAll('.announcement-bar__message');
    if (messages.length <= 1) return;
    const delay = parseInt(bar.dataset.delay, 10) || 4000;
    let idx = 0;
    setInterval(() => {
      messages[idx].classList.remove('is-active');
      idx = (idx + 1) % messages.length;
      messages[idx].classList.add('is-active');
    }, delay);
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawers() {
    document.addEventListener('click', (e) => {
      const open = e.target.closest('[data-drawer-open]');
      if (open) {
        const id = open.dataset.drawerOpen;
        const drawer = document.querySelector(`[data-drawer="${id}"]`);
        if (drawer) {
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      }
      const close = e.target.closest('[data-drawer-close]');
      if (close) {
        const drawer = close.closest('.mobile-drawer');
        if (drawer) {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('.mobile-drawer.is-open').forEach(d => {
          d.classList.remove('is-open');
          d.setAttribute('aria-hidden', 'true');
        });
        document.body.style.overflow = '';
      }
    });
  }

  /* ---------- Ajax add-to-cart ---------- */
  function initAjaxCart() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const originalText = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Ajout…'; }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await updateCartCount();
        showToast('Ajouté au panier ✓');
        if (btn) btn.innerHTML = 'Ajouté ✓';
      } catch (err) {
        console.error(err);
        showToast('Erreur — réessaye');
        if (btn) btn.innerHTML = originalText;
      } finally {
        setTimeout(() => {
          if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
        }, 1800);
      }
    });
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const data = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = data.item_count;
        el.dataset.cartCount = data.item_count;
      });
    } catch (e) { /* ignore */ }
  }

  /* ---------- Toast ---------- */
  function showToast(text) {
    let toast = document.querySelector('.cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('is-visible'), 2500);
  }

  /* ---------- UGC slider ---------- */
  function initUgcSlider() {
    document.querySelectorAll('[data-ugc-slider]').forEach(slider => {
      const track = slider.querySelector('[data-ugc-track]');
      if (!track) return;
      const prev = slider.querySelector('[data-ugc-prev]');
      const next = slider.querySelector('[data-ugc-next]');
      const step = () => {
        const card = track.querySelector('.ugc-card');
        return card ? card.offsetWidth + 16 : 320;
      };
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });

    /* video modal */
    const modal = document.querySelector('[data-ugc-modal]');
    if (!modal) return;
    const slot = modal.querySelector('[data-ugc-modal-video]');

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-ugc-play]');
      if (trigger) {
        const url = trigger.dataset.videoUrl;
        if (!url) return;
        slot.innerHTML = '';
        if (/youtube\.com|youtu\.be/.test(url)) {
          const id = url.match(/(?:youtu\.be\/|v=)([\w-]{11})/);
          if (id) slot.innerHTML = `<iframe src="https://www.youtube.com/embed/${id[1]}?autoplay=1" allow="autoplay" allowfullscreen></iframe>`;
        } else {
          slot.innerHTML = `<video controls autoplay playsinline><source src="${url}" type="video/mp4"></video>`;
        }
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      if (e.target.closest('[data-ugc-modal-close]')) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        slot.innerHTML = '';
        document.body.style.overflow = '';
      }
    });
  }

  /* ---------- About video trigger (inline replace) ---------- */
  function initAboutVideo() {
    document.querySelectorAll('[data-video-trigger]').forEach(wrap => {
      wrap.addEventListener('click', () => {
        const template = wrap.parentElement.querySelector('[data-video-src]');
        if (template) {
          wrap.innerHTML = template.innerHTML;
        }
      });
    });
  }

  /* ---------- Init on DOM ready ---------- */
  function init() {
    initAnnouncementBar();
    initDrawers();
    initAjaxCart();
    initUgcSlider();
    initAboutVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
